var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination_container"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.total,"current-page":_vm.currentpage},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }